(function () {
    'use strict';
    angular
        .module('app.widgets')
        .service('uploadService', uploadService)

    /* @ngInject */
    // function calendarService() {
    //     return{
    //         moveDateTimeZone:moveDateTimeZone
    //     };
    //
    //     function moveDateTimeZone(timezone, date) {
    //         if (timezone) {
    //             date.zone(timezone, true);
    //         }
    //         return date;
    //     }
    // }

    function uploadService($rootScope){
    this.CHANNEL = {
        UPLOAD_DATA_CHANGED : 'changed'
    };

    this.broadcast = function(channel, msg){
        console.log('broadUpload');
        if (channel && typeof channel === 'string') {
            $rootScope.$broadcast(channel, msg);
        }

    };
    this.listener = function(channel, callback){
        console.log('listener');
        if (channel && typeof channel === 'string' && callback && typeof callback === 'function') {
            return $rootScope.$on(channel, callback);
        }
    };
}
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/uploadService.js
 ** module id = 202
 ** module chunks = 0
 **/